import { useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { Botao, Cartao } from '../../componentes/base';
import { Alternador } from '../../componentes/formulario';
import { useToast } from '../../componentes/toast';
import { api, mensagemDeErro } from '../../nucleo/api';
import { podeNoWorkspace, trocaDeEmpresaLigada, useSessao } from '../../nucleo/sessao';

/**
 * Val1 (28/10): Admin > Configurações > Empresa > "Troca de empresa/vertical". Ligado (padrão), o seletor de empresa aparece
 * no perfil; desligado, o workspace é um ambiente único (a pessoa vê sempre todas as verticais liberadas para ela).
 */
export function CartaoTrocaDeEmpresa() {
  const { t } = useTranslation('configuracoes');
  const { t: tn } = useTranslation();
  const s = useSessao();
  const qc = useQueryClient();
  const toast = useToast();
  const podeEditar = podeNoWorkspace(s, 'configuracoes.editar');
  const salvo = trocaDeEmpresaLigada(s);
  const [ativa, setAtiva] = useState(salvo);
  const sujo = ativa !== salvo;
  const salvar = useMutation({
    mutationFn: () => api('PUT', '/configuracoes/troca-de-empresa', { ativa }),
    onSuccess: async () => {
      await s.recarregar();
      await qc.invalidateQueries();
      toast.sucesso(tn('comum.salvo'));
    },
    onError: (e) => toast.erro(mensagemDeErro(e)),
  });
  return (
    <Cartao titulo={t('empresa.troca.titulo')}>
      <div className="flex flex-col gap-4" data-troca-de-empresa="">
        <p className="text-sm text-tinta-3">{t('empresa.troca.ajuda')}</p>
        <div className="flex items-center justify-between gap-3 rounded-lg border border-borda px-3 py-2">
          <div className="min-w-0">
            <p className="text-sm font-medium text-tinta-1">{t('empresa.troca.ligar')}</p>
            <p className="text-xs text-tinta-3">{t('empresa.troca.ligarAjuda')}</p>
          </div>
          <Alternador marcado={ativa} aoMudar={setAtiva} rotulo={t('empresa.troca.ligar')} desabilitado={!podeEditar} />
        </div>
        {podeEditar && (
          <div className="flex flex-wrap justify-end gap-2">
            <Botao variante="fantasma" disabled={!sujo} onClick={() => setAtiva(salvo)}>
              {t('empresa.troca.descartar')}
            </Botao>
            <Botao disabled={!sujo} carregando={salvar.isPending} onClick={() => salvar.mutate()} data-salvar-troca="">
              {t('empresa.troca.salvar')}
            </Botao>
          </div>
        )}
      </div>
    </Cartao>
  );
}
